import { render, staticRenderFns } from "./ModuleSchedule.vue?vue&type=template&id=37fe4c0b&scoped=true&"
import script from "./ModuleSchedule.vue?vue&type=script&lang=js&"
export * from "./ModuleSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe4c0b",
  null
  
)

export default component.exports